import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { SectionPlaceholder } from "@/shared/components/SectionPlaceholder";
import { LayoutDashboard } from "lucide-react";
import { useAppShell } from "@/shell/app-shell-context";
import { activeCompanies } from "@/shared/utils/companies";

/**
 * `/dashboard` virou porta de entrada, não tela: o dashboard real é de
 * UMA empresa (`/empresas/:companyId/dashboard`), porque o recorte vem
 * de um relatório dela.
 *
 * A query string antiga é DESCARTADA de propósito. Links salvos carregam
 * o vocabulário do backend descartado (`publisherTypes=press`,
 * `media_type=...`), que hoje significa outra coisa — repassar às cegas
 * daria um dashboard vazio sem explicação, que é pior que chegar limpo.
 */
export function DashboardRoute() {
  const navigate = useNavigate();
  const { profile } = useAppShell();

  // Só as ativas: a desativada que o Máster recebe não é destino.
  const companies = activeCompanies(profile?.companies ?? []);
  const only = companies.length === 1 ? companies[0] : null;

  useEffect(() => {
    if (only) navigate(`/empresas/${only.id}/dashboard`, { replace: true });
    else if (companies.length > 1) navigate("/empresas", { replace: true });
  }, [only, companies.length, navigate]);

  if (companies.length > 0) return null;

  return (
    <SectionPlaceholder
      icon={LayoutDashboard}
      title="Dashboard"
      description="O dashboard mostra o recorte de uma amostra de uma empresa. Escolha uma empresa para começar."
      badge={false}
    />
  );
}
